import { Route, Routes, useLocation } from 'react-router-dom'

import Toolbar from 'common/components/Toolbar'
import { useFeatureFlag } from 'common/contexts/FeatureFlagsContext'
import { getParentPathname } from 'common/utils/navigation/pathUtils'

import ImportExportButton from 'features/DataManagement/Components/Buttons/ImportExportButton'
import ViewsAndMyViewsTabs from 'features/DataManagement/Components/Toolbar/ViewsAndMyViewsTabs'
import { IDataViewProps } from 'features/DataManagement/DataView'

import ViewsTabContent from './ViewsTabContent'

const DataViewList = ({ dvBasePath }: IDataViewProps) => {
  const { search } = useLocation()
  const dmBasePath = getParentPathname(dvBasePath)

  const dataExportLabel = useFeatureFlag('timp.IsDataExportEnabled', true)
    ? 'EXPORT DATA'
    : 'IMPORT/EXPORT DATA'

  return (
    <div className='flex flex-1 flex-col bg-gray-100'>
      <header className='bg-white px-28'>
        <div className='mb-10 mt-14'>
          <span
            className={[
              'block font-medium',
              'uppercase leading-none',
              'tracking-[0.03em] text-lighthouseBlue'
            ].join(' ')}
          >
            Data Management
          </span>
          <div className='flex justify-between'>
            <h1 className='mt-2 text-3xl font-semibold'>Data Views</h1>
            <ImportExportButton
              text={dataExportLabel}
              url={`${dmBasePath}import-export${search}`}
            />
          </div>
        </div>
        <Toolbar className='border-none px-0'>
          <ViewsAndMyViewsTabs dvBasePath={dvBasePath} />
        </Toolbar>
      </header>
      <div className='flex flex-1 overflow-y-auto'>
        <Routes>
          <Route
            path='list/views'
            element={<ViewsTabContent dvBasePath={dvBasePath} />}
          />
          <Route
            path='*'
            element={<ViewsTabContent dvBasePath={dvBasePath} />}
          />
        </Routes>
      </div>
    </div>
  )
}

export default DataViewList
